import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ROUTES, USER_ROLES } from '../../config/constants';
import { UserRole } from '../../types';
import LoadingSpinner from '../common/LoadingSpinner';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  const adminRoles: UserRole[] = [
    USER_ROLES.BACKOFFICE,
    USER_ROLES.SALES,
    USER_ROLES.FINANCE,
    USER_ROLES.IT_ADMIN
  ];

  if (!adminRoles.includes(user.role as UserRole)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;